import $ from "jquery";

class DateFilterController {
  constructor() {
    this.datePicker = $("input[type=radio][name=tabset_2]");
    this.eventPicker = $("input[type=radio][name=tabset_1]");
    this.eventWrapper = document.querySelector("#event-results");
    this.theDate;
    this.eventQuery;
    this.events();
  }

  events() {
    window.addEventListener("DOMContentLoaded", this.loadEvents.bind(this));

    for (var i = 0; i < this.datePicker.length; i++) {
      this.datePicker[i].addEventListener("change", this.date.bind(this));
    }

    for (var i = 0; i < this.eventPicker.length; i++) {
      this.eventPicker[i].addEventListener("change", this.event.bind(this));
    }
  }

  event(e) {
    this.eventWrapper.innerHTML = " ";
    this.eventWrapper.innerHTML = '<div class="spinner-loader"></div>';

    this.eventQuery = e.target.value;

    console.log("EVENT QUERY: ", this.eventQuery);

    this.theDate = "all";

    let allDatesTab = document.getElementById("tabset_2_six");
    allDatesTab.checked = true;

    this.loadEvents();
  }

  date(e) {
    this.eventWrapper.innerHTML = " ";
    this.eventWrapper.innerHTML = '<div class="spinner-loader"></div>';

    let language = document.querySelector(".lang-attribute").innerHTML;

    this.theDate = e.target.value;

    console.log("e, or event clicked", e);

    console.log("check lang: ", language);

    console.log("THE DATE:", this.theDate);

    if (language == "fr") {
      this.eventQuery = "competition-fr, workshops, conference, soirée, other";
    }
    if (language == "en") {
      this.eventQuery =
        "competition-en, workshop-en, conference-en, soirée-en, other-en";
    }

    let allEventsTab = document.getElementById("tabset_1_one");
    allEventsTab.checked = true;

    this.loadEvents();
  }

  myFunction() {
    this.postCount = -1;
    this.loadEvents();
  }

  loadEvents() {
    this.eventWrapper.innerHTML = " ";
    this.eventWrapper.innerHTML = '<div class="spinner-loader"></div>';

    let language = document.querySelector(".lang-attribute").innerHTML;

    if (this.theDate != undefined) {
      var date = this.theDate;
    } else {
      var date = "all";
    }

    console.log("LANG: ", language);

    if (this.eventQuery != undefined) {
      var event = this.eventQuery;
    } else {
      if (language == "fr") {
        var event = "competition-fr, workshops, conference, soirée";
      }
      if (language == "en") {
        var event = "competition-en, workshop-en, conference-en, soirée-en";
      }
    }

    console.log("date", date);
    console.log("event", event);

    $.ajax({
      type: "POST",
      url: jsforwp_globals.ajax_url,
      data: {
        action: "load_events",
        _ajax_nonce: jsforwp_globals.nonce,

        date: date,
        event: event,
      },

      success: (response) => {
        this.eventWrapper.innerHTML = response;
      },
      error: (response) => {
        console.log("Something went wrong");
        console.log(response);
      },
    });
  }
}

export default DateFilterController;
